// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lNKv","controls":"styles_controls__39UP0","charLimit":"styles_charLimit__1GnKp","input":"styles_input__13whn","send":"styles_send__2PzzY"};